import React from 'react'
import { Helmet } from 'react-helmet-async'
import SEO from '../../components/SEO'
import Footer from '../../components/Footer'
import Navbar from '../../components/Navbar'
import ProductsTitle from './components/ProductsTitle/ProductsTitle'
import ProductGrid from './components/ProductsCont/ProductGrid'
import ClientShowcase from './components/ClientShowcase/ClientShowcase'
import { structuredData } from '../../data/structuredData'

export default function Products() {
  return (
    <>
      <SEO
        title='Our Products'
        description='Explore the tools and platforms RaStegHub has built to solve real problems — ready for you to use today.'
        url='/products'
      />
      <Helmet>
        <script type='application/ld+json'>{JSON.stringify(structuredData)}</script>
      </Helmet>
      <div className="products">
        <Navbar />
        <ProductsTitle />
        <ProductGrid />
        <ClientShowcase />
        <Footer />
      </div>
    </>
  )
}